
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { FormServices } from 'src/app/services/form.services';
import { StepDataInterface } from 'src/app/system-utils/side-panel/side-panel.component';
import { IconServices } from 'src/app/services/icon.services';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ColDef, ColumnMovedEvent, ColumnResizedEvent, ColumnState, GridApi, GridReadyEvent, ICellRendererParams, IRowNode, RowClickedEvent, RowDoubleClickedEvent, RowNode } from '@ag-grid-community/core';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DialogService } from 'src/app/services/dialog.service';

import { UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

import { FormItemCanceling, FormItemConfiguration, FormItemEditData, FormItemSaving } from 'src/app/system-utils/form-item-component/form-item-component.component';
import { AdminServices } from 'src/app/services/AdminServices.js';
import { ThemeService } from 'src/app/services/theme.service.js';
import { LanguageServices } from 'src/app/services/LanguageServices.js';

export interface QueryConnSettings{
  NAME:string;
  FORMULA:string;
  HOSTNAME:string;
  USERNAME:string;
  PASSWORD:string;
  CODECOMPANY:string;
  ENCRYPTED:boolean;
  ICON:string;
}

export interface QueryExcutorSettings{
  ROWSFIELDS?:QueryConnSettings[];
  OPTIONS?:{
    canClipboard:boolean,
    canExport:boolean,
    showConnection:boolean,
    maxRows:number
  }
}


@Component({
    selector: 'query-executor-settings',
    templateUrl: './query-executor-settings.component.html',
    styleUrl: './query-executor-settings.component.scss',
    standalone: false
})

export class QueryExecutorComponentSettings implements OnInit,OnDestroy {
  
  private gridApi!: GridApi;
  editFace:boolean = false;
  selectedNodes: IRowNode<any>[];
  formItem:FormGroup;
  @ViewChild("outlet", {read: ViewContainerRef}) outletRef: ViewContainerRef;
  @ViewChild("content", {read: TemplateRef}) contentRef: TemplateRef<any>;

  resourceId = 'query_executor_sankhya_connections';
  formItemConfiguration: FormItemConfiguration[] = [

  {
      name:'NAME',
      description: 'Nome da Conexão',
      title:'Nome da Conexão',
      tooltip:'Informar o Nome da Conexão',
      type:'string',
      required:true
  },
  {
    name:'FORMULA',
    description: 'Fórmula',
    title:'Fórmula',
    tooltip:'Informar a Fórmula para Pesquisa',
    type:'formula',
    required:true,

  },
  /*{
    name:'HOSTNAME',
    description: 'HostName',
    title:'Endereço do Servidor',
    tooltip:'Informar o Endereço do Servidor',
    type:'string',
    required:true,
    hide:true
  },
  {
    name:'USERNAME',
    description: 'Usuário',
    title:'Usuário',
    tooltip:'Informar o Usuário de Acesso',
    type:'string',
    hide:true,
    required: true
  },
  {
    name:'ENCRYPTED',
    description: 'ENCRYPTED',
    title:'ENCRYPTED',
    tooltip:'ENCRYPTED',
    type:'string',
    hide:true,
    defaultValue: false
  },
  {
    name:'PASSWORD',
    description: 'Senha',
    title:'Senha',
    tooltip:'Informar a Senha de Acesso',
    type:'password',
    hide:true,
    required:true,
    hidePassWord:true,
    onClick:(data)=>{
        	
         if ( this.formItem.get('PASSWORD').value != null &&  this.formItem.get('ENCRYPTED').value == true ){
            this.formItem.get('PASSWORD').setValue(null);
            this.formItem.get('ENCRYPTED').setValue(false);
         }
    }
  },*/
  {
    name:'CODECOMPANY',
    description: 'Empresa',
    title:'Empresa',
    tooltip:'Informar a Empresa',
    type:'search',
    required:true,
    entityName:'Mktpcompanies',
    entityDesc:'Empresa',
    fieldName:'NAME',
    columnName:'CODECOMPANY',
    controlName:'CODECOMPANY'
  },
  {
    name:'ICON',
    description: 'Ícone',
    title:'Ícone',
    tooltip:'Informar o SVG do Ícone ( MKtpIcons )',
    type:'string',
    required: false
  }
]

 

  displayedColumns:ColDef[] = [
    
    {
      headerName: "Nome",
      field: "NAME",
      flex:3,
      resizable:true
    },
    // {
    //     headerName: "HostName",
    //     field: "HOSTNAME",
    //     flex:3,
    //     resizable:true
    // },
    {
      headerName: "Fórmula",
      field: "FORMULA",
      flex:1,
      resizable:true
    },
    // {
    //     headerName: "Usuário",
    //     field: "USERNAME",
    //     flex:1,
    //     resizable:true,
    //     hide:true
    // },
    // {
    //   headerName: "Senha",
    //   field: "PASSWORD",
    //   flex:1,
    //   resizable:true,
    //   cellRenderer: function (params: ICellRendererParams) {
    //     return   '******'
    //  },
    //  hide:true
    // },
    {
      headerName: "Empresa",
      field: "CODECOMPANY",
      flex:3,
      resizable:true
    },
    {
      headerName: "Icone",
      field: "ICON",
      flex:3,
      resizable:true
    }
  ];

  rowsField:any[];
  form:FormGroup;
  item: QueryExcutorSettings;
  stepData:StepDataInterface[] = [];
  subIcon:Subscription;
  icons:Observable<Object[]> = new Observable<Object[]>();
  colorDisable:boolean = true;
  editData:FormItemEditData = null;
  name: string;
  idUser: number;
  idDashBoard: number;
  tabName: string;
  newGadGet: boolean = false;
  filters: string[];
  constructor(
            @Inject(MAT_DIALOG_DATA) public dataDialog, 
            public dialogRef:MatDialogRef<any>,
            public formBuilder:FormBuilder,
            public formServices:FormServices,
            public iconServices:IconServices,
            private snackBar:SnackbarService,
            private dialogServices:DialogService,
            private userServices:UserConfigServices,
            private uas:UserAuthenticationServices,
            private ts:LanguageServices,
            private as:AdminServices,
            public ThemeService:ThemeService,
            public ls:LanguageServices
  ){}

  getRowId(params) {
    return params.data.NAME;
  }
  
  eventGridSelect(event: RowClickedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;    

    this.userServices.loadUserResource(this.uas.user.iduser,this.resourceId).subscribe({
      next:(data)=>{
          let arr:Object[] = data['Mktpuserpref'];
          if ( arr.length > 0){
            let obj = arr[0];
            if ( obj['PREFERENCE'] != null ){
              
              let config:ColumnState[] = JSON.parse(obj['PREFERENCE']);
              this.gridApi.applyColumnState({ state: config,applyOrder: true });
            }
          }
      }
    })
  }

  ngOnDestroy(): void {
    if ( this.subIcon != null ){ this.subIcon.unsubscribe();}
  }

  
  
  
  ngOnInit(): void {


    this.item = this.dataDialog == null? {
        showConnection: false,
        canExport: false,
        canClipboard: false,
        maxRows: 100
      } : this.dataDialog;
    
    this.idUser = this.uas.user.iduser;

    this.rowsField = this.item.ROWSFIELDS == null? [] : this.item.ROWSFIELDS;
    
    this.form = this.formBuilder.group({
        showConnection: new FormControl<boolean>(false),
        canExport: new FormControl<boolean>(false),
        canClipboard: new FormControl<boolean>(false),
        maxRows: new FormControl<number>(100),
    });


    this.formServices.refreshFormObject(this.form,this.item);
    //this.formServices.refreshFormObject(this.form.get('ROWSFIELDS') as FormGroup,this.item.ROWSFIELDS);

    this.buttonList.push(
      {
        color:"warn",
        description:"cancel",
        action: ()=>{
            this.sair();
        }  
      },
      {
      color:"primary",
      description:"save",
      action: ()=>{
          this.okFunction();
      }
    })

    this.stepData = [
        {
          buttonList:this.buttonList,
          info:"QUERY_EXCUTOR_SETTINGS.STEPDATA.GENERAL.INFO",
          name:"general",	
          sideDesc:"QUERY_EXCUTOR_SETTINGS.STEPDATA.GENERAL.SIDE_DESC",
          title:"QUERY_EXCUTOR_SETTINGS.STEPDATA.GENERAL.TITLE",
          
        },
        {
          buttonList:this.buttonList,
          info:"QUERY_EXCUTOR_SETTINGS.STEPDATA.CONN.INFO",
          name:"connection",	
          sideDesc:"QUERY_EXCUTOR_SETTINGS.STEPDATA.CONN.SIDE_DESC",
          title:"QUERY_EXCUTOR_SETTINGS.STEPDATA.CONN.TITLE",
          showCondition: ()=>this.form.get('showConnection').value
        }
    ]
  }

  okFunction(){
    
    let data = this.form.getRawValue();
    data.ROWSFIELDS = this.rowsField;
    this.dialogRef.close(data);
  }

  buttonList:ButtonList[] = [];
  

  add(){
    this.formItem = this.formBuilder.group({});

    this.editFace = true;
    this.editData = {
        index: -1,
        data: null
    };
  }

  remove(){

    if ( this.selectedNodes == null ){
      this.snackBar.showError("nolineselected");
      return;
    }

    let cnt = this.selectedNodes.length;
    
    if (cnt == 0) {
      this.snackBar.showError("nolineselected");
      return;
    }

    try {
      this.dialogServices.title = "dataremove";
      this.dialogServices.openNewDialog(
        this.ts.instant('confirmremove'),
        () => {
          this.selectedNodes.forEach(async (rowNode: RowNode) => {
            let x = rowNode.data;
            
            let i = this.rowsField.findIndex(d=>d['NAME']==x['NAME']);
            this.rowsField.splice(i,1);
            this.gridApi.applyTransaction({ remove: [rowNode.data] });
        })
      }
      );
    } catch (Exception) {
      throw Exception;
    }
  }

  onSavingArray(evento:FormItemSaving){
    if ( !this.formItem.valid ){
      this.snackBar.showError(this.formServices.getFormErrors(this.formItem,this.formItemConfiguration));
      this.form.updateValueAndValidity();
      return;
    }

    this.processPersistence(evento);
    // if ( evento.form.get("ENCRYPTED").value == false ) {
    //   this.as.encryptSankhyaData(evento.form.get("CODECOMPANY").value,evento.form.get("PASSWORD").value).subscribe({
    //     next:(data)=>{
    //       evento.form.get("ENCRYPTED").setValue(true);
    //       evento.form.get("PASSWORD").setValue(data['resultado']);
    //       this.processPersistence(evento);    
    //     },
    //     error:(err)=>{
    //       throw err;
    //     }
    //   }); 
    // }else{
    //   //this.processPersistence(evento);
    // }
  }

  processPersistence(evento:FormItemSaving){
    if ( evento.new ){
      this.rowsField.push(evento.form.getRawValue());
      this.gridApi.applyTransaction({add:[evento.form.getRawValue()]});
    }else{
      this.rowsField[evento.index] = evento.form.getRawValue();
      this.gridApi.applyTransaction({update:[evento.form.getRawValue()]})
    }
    this.editFace = false;
  }

  onCanceling(evento:FormItemCanceling){
      this.editFace = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {const compRef = this.outletRef.createEmbeddedView(this.contentRef);}, 0);
    
    //compRef.detectChanges();
  }

  selectRow(evento:RowDoubleClickedEvent){
      this.editFace = true;
      this.editData = {
        data:evento.data,
        index:evento.rowIndex
      }
      this.formItem = this.formBuilder.group({});
  }


  public onReoder(evento:ColumnMovedEvent): void {
    if ( evento.finished ){
      this.userServices.saveUserResource(this.resourceId,this.uas.user.iduser,evento.api.getColumnState());
    }
  }

  public onResize(event: ColumnResizedEvent): void {
    try {
      if (event.finished) {
          let config = event.api.getColumnState();
          this.userServices.saveUserResource(this.resourceId,this.uas.user.iduser,config);
        } 
    } catch (Exception) {
      throw Exception;
    }
  }


  sair(){
    this.dialogRef.close();
  }

}
